// Assentos de agente da conta. O limite so aparecia depois de tentar convidar
// e levar 402; com isto a lista mostra 'X de Y assentos em uso' e trava o
// Convidar quando nao sobra assento. Sem limite (total nulo), nao mostra nada.
export const agentSeats = (used, total) => {
  if (total === null || total === undefined) return null;
  const limit = Number(total);
  if (!Number.isFinite(limit)) return null;
  return { used, total: limit, full: used >= limit };
};
